// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.

export const getPlacements = (page) =>
  (Array.isArray(page?.blocks) ? page.blocks : []).filter(
    (placement) => placement?.blockId
  );

// minmax(0, 1fr) rather than 1fr: plain 1fr means minmax(auto, 1fr), and an auto
// minimum refuses to shrink below its content, which would push the grid past the
// viewport and bring back the window scrollbar.
export const gridStyle = (page) => ({
  gridTemplateColumns: `repeat(${page?.columns || 12}, minmax(0, 1fr))`,
  gridTemplateRows: `repeat(${page?.rows || 12}, minmax(0, 1fr))`,
  gap: `${page?.gap ?? 24}px`,
});

export const cellStyle = (placement) => ({
  gridColumn: `${placement?.col} / span ${placement?.colSpan}`,
  gridRow: `${placement?.row} / span ${placement?.rowSpan}`,
});

const DIVIDER_SIDES = {
  l: "border-l",
  r: "border-r",
  b: "border-b",
  t: "border-t",
};

// gridDivider is a string of sides in any order ("lr", "tb", "lrbt").
// Legacy boolean true stays right + bottom.
export const dividerClass = (gridDivider) => {
  if (gridDivider === true) return "border-r border-b border-general-border";
  if (typeof gridDivider !== "string") return "";

  const sides = [
    ...new Set(gridDivider.toLowerCase().replace(/[^lrbt]/g, "")),
  ].map((side) => DIVIDER_SIDES[side]);

  return sides.length ? `${sides.join(" ")} border-general-border` : "";
};

// Stages are past/current/future by date, so the timeline stays right as the
// calendar advances. The last stage on or before today is the current one.
export const stageStates = (stages) => {
  const now = Date.now();
  const startOfToday = new Date().setHours(0, 0, 0, 0);

  let currentIndex = -1;
  (stages || []).forEach((stage, index) => {
    if (!stage?.date) return;
    if (new Date(stage.date).getTime() <= now) currentIndex = index;
  });

  return (stages || []).map((stage, index) => {
    if (index === currentIndex) return "current";
    if (!stage?.date) return index < currentIndex ? "past" : "future";
    return new Date(stage.date).setHours(0, 0, 0, 0) < startOfToday
      ? "past"
      : "future";
  });
};

export const formatEventDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "America/New_York",
    timeZoneName: "short",
  });
};

